// LoginPage.tsx
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import MainHeader from "../pages/MainHeader";
import { useNavigate } from "react-router-dom";
import { routes } from "../routes/routes-names";
import { useCallback } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { authService } from "../lib/api/auth";
import { tokenManager } from '../lib/token-manager';
import Swal from "sweetalert2";

const tsmclogo = require("../assets/images/TSMC_LOGO.jpg");
const UserWelcome: React.FC = () => {
  return (<>

    <div className="container-fluid  pt-3 d-flex align-items-center justify-content-center bg-light">
      <div className="row w-100" style={{ maxWidth: "900px" }}>

        {/* Right Side - Login Form */}
        <div className="col-md-6 p-5 d-flex flex-column justify-content-center">
          <div className="text-center mb-4">
            <h4 className="mt-2 cme-header">Welcome  Organization </h4> 
            <img src={tsmclogo} alt="Logo" style={{ width: "200px" }} height={200} className="me-2" />
            
          </div>
            
        </div>
      </div>
    </div>
  </>
  );
};

export default UserWelcome;
